import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { AuthenticationProvider } from "./context/Authentication";
import BlankPage from "./pages/BlankPage";
import keycloak, { config, initOptions } from "./utils/keycloak";
import "./utils/i18n";
import "./index.css";
import "./fonts/EncodeSansBlack.ttf";
import "./fonts/EncodeSansBold.ttf";
import "./fonts/EncodeSansLight.ttf";
import "./fonts/EncodeSansMedium.ttf";
import "./fonts/EncodeSansRegular.ttf";
import "bootstrap/dist/css/bootstrap.min.css";
import "ar-poncho/dist/css/poncho.min.css";
import "ar-poncho/dist/css/icono-arg.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthenticationProvider
      config={config}
      initOptions={initOptions}
      minExpiration={70}
      loadingComponent={<BlankPage />}
    >
      <App />
    </AuthenticationProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.debug))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
